import { PendingProjectsComponent } from "@/components/pending";
import { ProjectDirectory } from "@/components/project/project-directory";
import { QueryBoundary } from "@/components/query-boundary";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_app/projects/")({
  component: ProjectsPage,
  validateSearch: z.object({
    q: z.string().optional(),
    sort: z.enum(["updated", "name"]).optional().catch(undefined),
  }),
  loader: ({ context: { queryClient, orpc } }) => {
    void queryClient.ensureQueryData(orpc.projects.getAll.queryOptions());
  },
  head: () => ({ meta: [{ title: "Papier - Projects" }] }),
});

function ProjectsPage() {
  return (
    <main className="min-h-full bg-muted/25">
      <QueryBoundary
        suspenseFallback={
          <div className="mx-auto max-w-[1440px] px-4 py-8 sm:px-8 lg:px-12">
            <PendingProjectsComponent />
          </div>
        }
      >
        <ProjectDirectory />
      </QueryBoundary>
    </main>
  );
}
